import { is_fighter } from "../../entity";
import { Entity } from "../../entity/Entity";
import { UIComponent } from "./UIComponent";

export class PlayerScore extends UIComponent {
  static override readonly TAGS: string[] = ["PlayerScore"];
  get index(): number { return this.num(0) ?? -1 }
  get lose(): boolean | undefined {
    const { fighter } = this;
    if (!fighter) return void 0;
    if (fighter.hp > 0) return false;
    for (const o of this.world.entities) {
      if (o !== fighter && is_fighter(o) && o.hp > 0 && o.team === fighter.team)
        return false;
    }
    return true;
  }
  get fighter(): Entity | undefined {
    const { index } = this;
    if (index < 0) return void 0;
    const arr = Array.from(this.world.puppets)
    if (index >= arr.length) return void 0
    return arr[index][1];
  }

  override update(): void {
    this.node.visible = !!this.fighter;
  }
}
